import React from 'react';

import { useFormSelector } from '../../../custom-hooks';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { getEvaluatedExpression, getTranslatedLabel } from '../../selectors/form-manager.selectors';
import { getActiveTabs } from '../../selectors/runtime.selectors';
import { equalityFn } from '../../utils/form-manager.utils';
import VirtualDynamicField from '../VirtualDynamicField';

const SSVirtualSingleTab = ({ id, entityName, childrenNodes, index, isHidden, isViewOnly }) => {
  const label = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.LABEL,
  });
  const translatedLabel = useFormSelector(getTranslatedLabel, {
    entityName,
    label,
  });
  const activeTabs = useFormSelector(getActiveTabs, {}, equalityFn);
  const instanceId = `${id}#[${index}]`;

  return childrenNodes.map((childObj) => (
    <VirtualDynamicField
      id={childObj}
      key={`${childObj}#${index.join(',')}`}
      index={index}
      isParentHidden={isHidden}
      isParentViewOnly={isViewOnly}
      containersProps={[{ label: translatedLabel, id, isActive: activeTabs.includes(instanceId) }]}
    />
  ));
};

export default SSVirtualSingleTab;
